// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import * as types from './actionTypes';

export function requestPageData(data) {
  return {
    type: types.FAQS_REQUEST_PAGE_DATA,
    ...data
  };
}

export function requestPageDataSuccess(data) {
  return {
    type: types.FAQS_REQUEST_PAGE_DATA_SUCCESS,
    data,
  };
}
